<div class="detail-display-container" *ngIf="this.product.productVariants != null">
    <!--------------------------------------------------------------->
    <app-detail-display-variant-version-selector *ngIf="this.product != null" [product]="product" [dataType]="'PRODUCT'"
        (onVersionChosen)="onVersionSelected($event)">
    </app-detail-display-variant-version-selector>
    <!--------------------------------------------------------------->
    <div class="desc" *ngIf="version.description && version.description?.length > 0"
        [class]="{ hidden: !this.showComplete }" [innerHTML]="this.version.description"></div>
    <div>
        <br />
        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 0">Produkttypen</h3>
            <mat-slide-toggle class="example-margin" color="accent" [checked]="ptgToggle"
                (change)="ptgToggle = !ptgToggle"></mat-slide-toggle>
        </div>
        <h5 style="font-style: italic">
            Zugeordnete Produktkategorien für diese Produktversion
        </h5>
        <div *ngIf="ptgToggle">
            <mat-chip-list>
                <mat-chip *ngFor="let ptgVersionFeature of ptgVersionFeatures" color="accent" [class]="{
                        fullfilledPTG:
                            ptgVersionFeature.doesProjectFulfillAllFeaturesOfPTGVersion
                    }" selected>{{ ptgVersionFeature.ptgName }}</mat-chip>
            </mat-chip-list>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>
        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 0">Features</h3>
            <mat-slide-toggle class="example-margin" color="accent"
                (change)="productFeatureToggle = !productFeatureToggle"
                [checked]="productFeatureToggle"></mat-slide-toggle>
        </div>
        <h5 style="font-style: italic">
            Vom Produktanbieter definierte Produkteigenschaften
        </h5>
        <div #productFeatureList *ngIf="productFeatureToggle">
            <mat-chip-list>
                <mat-chip *ngFor="let productFeature of productFeatures" color="accent" selected>{{ productFeature
                    }}</mat-chip>
            </mat-chip-list>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>
    </div>
    <div>
        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 0">Merkmale</h3>
            <mat-slide-toggle class="example-margin" color="accent" (change)="attributeToggle = !attributeToggle"
                [checked]="attributeToggle"></mat-slide-toggle>
        </div>
        <h5 style="font-style: italic">
            Von den BIMSWARM-Fachgruppen vorgegebene Produkteigenschaften
        </h5>
        <div *ngIf="attributeToggle">
            <div *ngFor="let ptgVersionFeature of ptgVersionFeatures">
                <app-product-type-group-feature-display
                    [ptgVersionFeatures]="ptgVersionFeature"></app-product-type-group-feature-display>
            </div>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>
        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 0">Allgemeine Merkmale</h3>
            <mat-slide-toggle class="example-margin" color="accent"
                (change)="commonFeaturesToggle = !commonFeaturesToggle"
                [checked]="commonFeaturesToggle"></mat-slide-toggle>
        </div>
        <h5 style="font-style: italic">
            Von BIMSWARM vorgegebene Produkteigenschaften
        </h5>
        <div *ngIf="commonFeaturesToggle">
            <app-product-detail-display-common-features
                [commonFeatures]="productCommonFeatures"></app-product-detail-display-common-features>
        </div>
    </div>
</div>